import { ReactNode } from 'react';
import { View } from 'react-native-animatable';
import { styles } from './styles';

type Props = {
  leftGrid: ReactNode;
  rightGrid: ReactNode;
};

export const SelectLayout = ({ leftGrid, rightGrid }: Props) => {
  return (
    <View style={styles.container}>
      <View style={styles.containerLeft}>{leftGrid}</View>
      <View style={styles.containerRight}>{rightGrid}</View>
    </View>
  );
};
